import { take } from "rxjs/operators";
import { ReplaySubject } from "rxjs";

class ExternalApiService {
  private cartItemsSubject = new ReplaySubject(1);

  public getCartItems() {
    return this.cartItemsSubject.asObservable().pipe(take(1));
  }

  public onDestroy() {
    if (!this.cartItemsSubject.closed) {
      this.cartItemsSubject.complete();
    }
    this.cartItemsSubject.unsubscribe();
  }

  public emitCartItems(cartItems: any) {
    if (!this.cartItemsSubject.closed) {
      this.cartItemsSubject.next(cartItems);
      this.cartItemsSubject.complete();
    }
  }
}

let externalApiService = new ExternalApiService();

export function bootstrap() {
  if (typeof window !== "undefined") {
    if (!(window as any).wbmApi) {
      (window as any).wbmApi = {};
    }

    (window as any).wbmApi.getCartItems =
      externalApiService.getCartItems.bind(externalApiService);
  }
}

export function destroy() {
  externalApiService.onDestroy();
}

export function emitCartItems(cartItems: any) {
  externalApiService.emitCartItems(cartItems);
}
